module.exports = __webpack_public_path__ + "static/img/monthly-card.ce374bd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/payment/monthly-card.png
// module id = eglx
// module chunks = 1